import CrossSolid from '@simplywallst/ui-core/icons/CrossSolid';
import TickSolid from '@simplywallst/ui-core/icons/TickSolid';
import { cn } from '@simplywallst/ui-core/next';
import type { NodeViewProps } from '@tiptap/react';
import { NodeViewWrapper } from '@tiptap/react';
import { CircularProgress } from './CircularProgress';
import { RTE_FILE_UPLOAD_EVENT_NAME } from '../../hooks/useFileUpload';

export const ImageUploadProgressNodeWrapper = ({
  node,
  deleteNode,
}: NodeViewProps) => {
  const isComplete = node.attrs.progress === 100;

  return (
    <NodeViewWrapper className="image-upload-progress">
      <div
        className={cn(
          'bones grid min-h-[300px] w-full place-content-center',
          isComplete && 'animate-pulse'
        )}
      >
        <button
          className={cn(
            'group relative size-[50px] rounded-full',
            !isComplete && 'hover:bg-bad-subtle'
          )}
          type="button"
          onClick={() => {
            !isComplete &&
              document.dispatchEvent(
                new CustomEvent(RTE_FILE_UPLOAD_EVENT_NAME)
              );

            deleteNode();
          }}
          aria-label="Abort upload"
        >
          <CircularProgress
            sqSize={50}
            percentage={node.attrs.progress}
            strokeWidth={4}
            color={
              isComplete ? 'var(--s-color-good)' : 'var(--s-color-brand-01)'
            }
          />
          <div className="absolute inset-0 grid place-content-center">
            {isComplete ? (
              <TickSolid className="size-x4 fill-good transition-colors" />
            ) : (
              <CrossSolid className="size-x4 fill-soft transition-colors group-hover:fill-bad" />
            )}
          </div>
        </button>
      </div>
    </NodeViewWrapper>
  );
};
